import { Typography } from '@mui/material';
import { colors } from 'crono-fe-common/theme';
import React from 'react';
import { InformationTaskCardWrapper } from './style';
import IconSWarning from 'crono-fe-common/icons/Icon-S-Warning';
import { cn } from 'utils/style-utils';
import InfoIcon from 'crono-fe-common/icons/Info-Icon';
import StrategyIssueType from 'crono-fe-common/types/strategyIssueType';

interface IProps {
  text: string | React.JSX.Element;
  type: StrategyIssueType;
}

const InformationTaskCard = ({ text, type }: IProps) => {
  const cardContentColor =
    type === 'error' ? colors.inactiveHover : colors.orangeDark;

  return (
    <InformationTaskCardWrapper
      className={cn({
        warning: type === 'warning',
        error: type === 'error',
      })}
    >
      {type === 'error' ? (
        <IconSWarning
          color={cardContentColor}
          size={16}
          style={{ minHeight: '16px', minWidth: '16px' }}
        />
      ) : (
        <InfoIcon
          color={cardContentColor}
          size={16}
          style={{ minHeight: '16px', minWidth: '16px' }}
        />
      )}

      <Typography
        fontSize={'14px'}
        lineHeight={'18px'}
        fontWeight={500}
        color={cardContentColor}
      >
        {text}
      </Typography>
    </InformationTaskCardWrapper>
  );
};

export default InformationTaskCard;
